// [Codex 2026-07-03] Route app-wide quick annotations into CAO dock state.
import { useCallback, useEffect, useState } from "react";
import {
  QUICK_ANNOTATE_EVENT,
  readQuickAnnotateEvent,
  type QuickAnnotateContext,
} from "../lib/quick-annotate";

interface QuickAnnotateDockInput {
  isMobile: boolean;
  onOpenDesktop: () => void;
  onOpenMobile: () => void;
}

export function useQuickAnnotateDock({
  isMobile,
  onOpenDesktop,
  onOpenMobile,
}: QuickAnnotateDockInput): {
  quickAnnotateContext: QuickAnnotateContext | null;
  closeQuickAnnotate: () => void;
} {
  const [quickAnnotateContext, setQuickAnnotateContext] =
    useState<QuickAnnotateContext | null>(null);

  const closeQuickAnnotate = useCallback(() => {
    setQuickAnnotateContext(null);
  }, []);

  useEffect(() => {
    const openQuickAnnotate = (event: Event) => {
      const context = readQuickAnnotateEvent(event);
      if (!context) return;
      setQuickAnnotateContext(context);
      if (isMobile) {
        onOpenMobile();
        return;
      }
      onOpenDesktop();
    };
    window.addEventListener(QUICK_ANNOTATE_EVENT, openQuickAnnotate);
    return () =>
      window.removeEventListener(QUICK_ANNOTATE_EVENT, openQuickAnnotate);
  }, [isMobile, onOpenDesktop, onOpenMobile]);

  return { quickAnnotateContext, closeQuickAnnotate };
}
